<form [formGroup]="editFormPerson"
    [class]="isMobile() ? 'w-screen h-full' : 'w-screen h-[80vh] md:h-[85vh] md:w-[65vw] 4xl:max-w-7xl md:max-h-[95vh] flex flex-col justify-between'"
    class="m-auto bg-lightCardBG
dark:bg-darkCardBG">
    <div
        class="w-full py-3 px-5 flex items-center justify-between border-b border-lightMode-300 dark:border-darkMode-700">
        <p
            class="text-lightMode-800 dark:text-darkMode-100 font-label md:text-xl font-bold">
            ویرایش اطلاعات
        </p>
        <button (click)="$event.preventDefault()" matRipple
            [class]="isMobile() ? 'w-10 h-10' : 'w-12 h-12'"
            class="flex items-center justify-center rounded-full hover:bg-[#8080802a] ease-in-out duration-100"
            (click)="closeModal()">
            <mat-icon aria-hidden="true" data-mat-icon-type="font"
                [class]="isMobile()?'text-2xl':'text-3xl'"
                class="text-lightMode-800 dark:text-darkMode-100 tools-icon ">
                close
            </mat-icon>
        </button>
    </div>

    <div [class]="isMobile() ? 'max-h-[calc(100vh-135px)]' : 'max-h-[80vh]'"
        class="w-full py-3 px-[5%] overflow-y-scroll scrollsbar-hidden flex-col items-center justify-center text-lightMode-800 dark:text-darkMode-100 mb-3">
        <div class="w-full grid grid-cols-2 md:gap-5">
            <div class="col-span-2 lg:col-span-1 md:my-3">
                <label for="profile-header-first-name"
                    class="font-label py-2 flex gap-2">
                    نام *
                    <h2 *ngIf="formValidator.first_name=='INVALID'"
                        class="text-[0.8rem] text-red-600 dark:text-red-500">{{errorObjectFirstName}}</h2>
                </label>
                <input #first_name
                    (keyup)="denySignCharecter('first_name',first_name.value)"
                    (keydown)="formValidator.first_name='VALID'"
                    [class]="formValidator.first_name=='INVALID'?'outline-red-600 dark:outline-red-700':'outline-lightMode-300 dark:outline-darkMode-700'"
                    required formControlName="first_name"
                    [value]="item.first_name"
                    (keyup)="getCurrentCharacter($event , 'first_name')"
                    id="profile-header-first-name" maxlength="30" type="text"
                    class="w-full py-2 md:py-3 px-4 bg-lightBG dark:bg-darkBG authInput text-inherit outline outline-1 h-[40px] md:h-[45px] rounded-full-input">
                <p
                    class="text-lightMode-600 dark:text-darkMode-300 w-full flex flex-row-reverse">
                    <span>{{charCounter.first_name.toString() |
                        convertToPersian}}</span>
                    <span> / </span>
                    <span>۳۰</span>
                </p>
            </div>
            <div class="col-span-2 lg:col-span-1 md:my-3">
                <label for="profile-header-last-name"
                    class="font-label py-2 flex gap-2">
                    نام خانوادگی *
                    <h2 *ngIf="formValidator.last_name=='INVALID'"
                        class="text-[0.8rem] text-red-600 dark:text-red-500">{{errorObjectLastName}}</h2>
                </label>
                <input #last_name
                    (keyup)="denySignCharecter('last_name',last_name.value)"
                    (keydown)="formValidator.last_name='VALID'"
                    [class]="formValidator.last_name=='INVALID'?'outline-red-600 dark:outline-red-700':'outline-lightMode-300 dark:outline-darkMode-700'"
                    [(ngModel)]="item.last_name" required
                    formControlName="last_name"
                    (keyup)="getCurrentCharacter($event , 'last_name')"
                    id="profile-header-last-name" maxlength="30" type="text"
                    class="w-full py-2 md:py-3 px-4 bg-lightBG dark:bg-darkBG authInput text-inherit outline outline-1 h-[40px] md:h-[45px] rounded-full-input">
                <p
                    class="text-lightMode-600 dark:text-darkMode-300 w-full flex flex-row-reverse">
                    <span>{{charCounter.last_name.toString() |
                        convertToPersian}}</span>
                    <span> / </span>
                    <span>۳۰</span>
                </p>
            </div>

        </div>
        <div class="w-full md:my-5">
            <label for="profile-header-activity-location"
                class="font-label py-2 px-3">
                تخصص
            </label>
            <input formControlName="profile_text" [value]="item.profile_text"
                (keyup)="getCurrentCharacter($event , 'location')"
                id="profile-header-activity-location" maxlength="50" type="text"
                class="w-full py-2 md:py-3 px-4 bg-lightBG dark:bg-darkBG authInput text-inherit rounded-full outline outline-1 outline-lightMode-300 dark:outline-darkMode-700 h-[40px] md:h-[45px]"
                placeholder="مثال: کارشناس ارشد تحلیل داده...">
            <p
                class="text-lightMode-600 dark:text-darkMode-300 w-full flex flex-row-reverse">
                <span>{{charCounter.location.toString() |
                    convertToPersian}}</span>
                <span> / </span>
                <span>۵۰</span>
            </p>
        </div>
        <div id="search-select-parent" class="w-full mb-3">
            <label for="field" class="font-label py-2 px-3 mb-2">
                شهر سکونت *
                <h2 *ngIf="formValidator.city =='INVALID'"
                    class="text-[0.8rem] text-red-600 dark:text-red-500">{{errorObjectLastName}}</h2>
            </label>
            <app-search-select [initSelectItem]="item.city" [type]="'city'"
                [isCheck]="isSubmitted"
                [config]="{rounded:true,roundedFull:true}"
                (emitId)="getCityId($event)"></app-search-select>
        </div>
        <div class="w-full md:my-5">
            <label for="profile-header-slogan" class="font-label py-2 px-3">
                توضیحات
            </label>
            <textarea formControlName="info" [value]="item.info"
                (keyup)="getCurrentCharacter($event , 'info')"
                id="profile-header-info" maxlength="600" type="text"
                class="w-full p-3  my-1 bg-lightBG dark:bg-darkBG text-inherit authInput leading-7 outline-lightMode-300 dark:outline-darkMode-700 rounded-md outline outline-1"
                rows="4"
                placeholder="ویژگی های حرفه ای و شخصیتی شما..."></textarea>
            <p
                class="text-lightMode-600 dark:text-darkMode-300 w-full flex flex-row-reverse">
                <span>{{charCounter.info.toString() | convertToPersian}}</span>
                <span> / </span>
                <span>۶۰۰</span>
            </p>
        </div>
    </div>
    <div [class]="isMobile()?'absolute':''"
        class="flex flex-row-reverse py-3 px-5 border-t border-lightMode-300 dark:border-darkMode-700 w-full bg-lightCardBG
    dark:bg-darkCardBG bottom-14">
        <button [disabled]="modalService.waiting" (click)="edit()" matRipple
            type="submit"
            class="activeBG py-1 px-8 h-[36px] text-white w-full md:w-auto text-lg rounded-full">
            <div *ngIf="modalService.waiting;else edit_entity"
                class="lds-ring"><div></div><div></div><div></div><div></div></div>
            <ng-template #edit_entity>ثبت</ng-template>
        </button>
    </div>
</form>